import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  DecisionOnDevelopmentConditionsTerrainInfoSectionComponent
} from './sections/decision-on-development-conditions-terrain-info-section/decision-on-development-conditions-terrain-info-section.component';
import {
  DecisionOnDevelopmentConditionsInvestmentCharacteristicsSectionComponent
} from './sections/decision-on-development-conditions-investment-characteristics-section/decision-on-development-conditions-investment-characteristics-section.component';
import {
  DecisionOnDevelopmentConditionsCommunicationServiceSectionComponent
} from './sections/decision-on-development-conditions-communication-service-section/decision-on-development-conditions-communication-service-section.component';

export const stages = [
  'Wnioskodawca',
  'Dane wniosku',
  'Teren objęty wnioskiem',
  'Charakterystyka inwestycji',
  'Obsługa komunikacyjna',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../teren-objety-wnioskiem',
  cancelUrl: '../wnioskodawca',
  addApplicationSubjectControl: true,
  applicationSubjectControlType: 'label',
  applicationSubjectDefaultValue: 'Wniosek o ustalenie warunków zabudowy'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../obsluga-komunikacyjna',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const decisionOnDevelopmentConditionsRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: DecisionOnDevelopmentConditionsTerrainInfoSectionComponent,
    path: ':appId/teren-objety-wnioskiem'
  },
  {
    component: DecisionOnDevelopmentConditionsInvestmentCharacteristicsSectionComponent,
    path: ':appId/charakterystyka-inwestycji'
  },
  {
    component: DecisionOnDevelopmentConditionsCommunicationServiceSectionComponent,
    path: ':appId/obsluga-komunikacyjna'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
